import React from 'react'

import { useIntl } from 'react-intl'

import {
  useRecoilValue,
  useResetRecoilState,
  useRecoilCallback
} from 'recoil'

import {
  Button,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot
} from 'mailup-web-components'

import {
  modalStopCampaignState
} from '../recoil/state/modals'

import {
  stopRunningCampaignConfirmCallback,
  stopScheduledCampaignConfirmCallback
} from '../recoil/callbacks/callbacks'

import { useConditions } from 'Hooks'
import { notifyParent } from 'Helpers/notifyParent'
import partial from 'Helpers/partial'

const ModalStopCampaign = () => {
  const intl = useIntl()
  const [canEdit] = useConditions(['uo:CONTENTSSOURCES'])

  const {
    show,
    idList,
    idSending,
    idSource,
    mode
  } = useRecoilValue(modalStopCampaignState)
  const closeModal = useResetRecoilState(modalStopCampaignState)

  const handleEdit = () => {
    closeModal()
    notifyParent('setCurrentList', [idList, `App.aspx#/contentsSourcesAddEdit/${idSource}`, true])
  }

  const handleConfirm = partial(useRecoilCallback(
    mode === 'running'
      ? stopRunningCampaignConfirmCallback
      : stopScheduledCampaignConfirmCallback
    , [mode]), idSending)

  return (
    <Modal
      show={show}
      showClose
      data-mu-test='modal-stop-campaign'
      onClose={closeModal}
    >
      <ModalHead title={intl.formatMessage({ id: 'Load.Schedulation.stopSendingCampaignModalTitle' })} />
      <ModalBody>{intl.formatMessage({ id: 'Load.Schedulation.stopSendingCampaignModalDescr' })}</ModalBody>
      <ModalFoot>
        {canEdit &&
          <Button
            kind='secondary'
            onClick={handleEdit}
          >{intl.formatMessage({ id: 'Load.Schedulation.stopSendingCampaignModalSourceBtn' })}
          </Button>}
        <Button
          kind='primary'
          onClick={handleConfirm}
        >{intl.formatMessage({ id: 'Load.Schedulation.stopSendingCampaignModalStopBtn' })}
        </Button>

      </ModalFoot>

    </Modal>
  )
}

export default ModalStopCampaign
